import { useIntl } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import messages from '@utils/messages'
import { AemTopNavItem } from '@src/types/graphql-types'
import { useAemHeaderFooterQuery } from '@src/queries/AemQuery.generated'
import ProductCategoryGroup from './ProductCategoryGroup'
import { Unstable_Grid2 as Grid } from '@mui/material'

const useStyles = makeStyles()((theme) => ({
  container: {
    margin: theme.spacing(10, 0),
    overflow: 'hidden',
  },
  sectionHeading: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
  },
}))

const ProductCategories = () => {
  const { formatMessage } = useIntl()
  const { classes } = useStyles()
  const { data } = useAemHeaderFooterQuery()

  // if no data, don't display ProductCategories
  if (!data?.aemHeaderFooter?.header?.topnav) return null

  const productCategories = data.aemHeaderFooter.header.topnav[1]?.items
  const productCategoryChunks: any[] = []

  // three column chunks outlined in PDP-156
  const chunkSize = 3

  // create chunks of 3 product category groups
  if (productCategories) {
    for (let i = 0; i < productCategories?.length; i += chunkSize) {
      const chunk = productCategories.slice(i, i + chunkSize)
      productCategoryChunks.push(chunk as AemTopNavItem)
    }
  }

  return (
    <Grid xs={12} className={classes.container}>
      <h5 className={classes.sectionHeading}>
        {formatMessage(messages.SHOP_BY_PRODUCT_CATEGORY)}
      </h5>
      {productCategoryChunks.map((chunk) => {
        return <ProductCategoryGroup key={chunk.title} lists={chunk} />
      })}
    </Grid>
  )
}

export default ProductCategories
